import React, { useEffect, useState } from "react";
import { chatMessageRepo, chatThreadRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { useMockCustomer } from "./useMockCustomer";
import { formatTime, useAsync } from "../../components/ui";

export default function CustomerChat() {
  const { orgId, toast } = useApp();
  const { tx } = useI18n();
  const { customer } = useMockCustomer(orgId);
  // แชทในพอร์ทัล = thread ช่องทาง "portal" ของลูกค้าคนนี้ (thread LINE/FB/IG เป็นของฝั่งร้าน)
  const { data: thread, reload } = useAsync(
    () =>
      customer
        ? chatThreadRepo.all(orgId, (row) => row.customerId === customer.id && row.channel === "portal").then((rows) => rows[0] || null)
        : Promise.resolve(null),
    [orgId, customer]
  );

  const [messages, setMessages] = useState([]);
  const [draft, setDraft] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!thread) return;
    chatMessageRepo.all(orgId, (row) => row.threadId === thread.id).then((rows) => setMessages(rows.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))));
  }, [orgId, thread]);

  const send = async () => {
    const text = draft.trim();
    if (!text || !customer || sending) return;
    setSending(true);
    try {
      const now = new Date().toISOString();
      // ยังไม่มีบทสนทนา -> สร้างใหม่ตอนส่งข้อความแรก
      const current =
        thread ||
        (await chatThreadRepo.create(orgId, {
          customerId: customer.id,
          customerName: customer.name,
          channel: "portal",
          lastMessage: text,
          unread: 0,
          status: "open",
          updatedAt: now,
        }));
      const message = await chatMessageRepo.create(orgId, { threadId: current.id, from: "customer", text, createdAt: now });
      await chatThreadRepo.update(orgId, current.id, { lastMessage: text, unread: Number(current.unread || 0) + 1, status: "open", updatedAt: now });
      setMessages((rows) => [...rows, message]);
      setDraft("");
      if (!thread) reload();
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="chat-panel" style={{ height: "calc(100vh - 220px)", border: "1px solid var(--line)", borderRadius: 14, overflow: "hidden" }}>
      <div className="chat-panel__body">
        {!messages.length ? (
          <div className="u-center u-muted u-fs-13" style={{ margin: "auto" }}>
            {tx("เริ่มต้นบทสนทนากับเจ้าหน้าที่ — พิมพ์ข้อความด้านล่างได้เลย ทางร้านจะตอบกลับในหน้านี้", "Start a conversation with our staff — type below and the shop will reply here")}
          </div>
        ) : null}
        {messages.map((message) => (
          <div key={message.id} className={`chat-bubble ${message.from === "customer" ? "is-mine" : ""}`} style={message.from === "customer" ? { marginLeft: "auto" } : undefined}>
            {message.text}
            <span className="chat-bubble__time">{formatTime(message.createdAt)}</span>
          </div>
        ))}
      </div>
      <div className="chat-panel__foot">
        <input className="input-crm" placeholder={tx("พิมพ์ข้อความ...", "Type a message...")} value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} />
        <button type="button" className="btn-crm btn-primary-crm" disabled={sending || !customer} onClick={send}>{tx("ส่ง", "Send")}</button>
      </div>
    </div>
  );
}
